// extracted by mini-css-extract-plugin
module.exports = {"exception-page":"ErrorPage_exception-page__1NAsf","ep-body":"ErrorPage_ep-body__1OgRl"};